const $ = require('jquery')

const { BREAKPOINT } = require('./api')
const breadcrumbComponent = require('./breadcrumb')

const $window = $(window)

// =========================================================================
// Main search
// =========================================================================
const mainSearch = {
  init () {
    const _ = $('.stage').not('.stage_experienceEdit').find('.main-search')
    const searchDesktopH = $('.main-search--advanced.main-search--no-header').outerHeight(true)
    const mainWrap = $('#main')

    if (_.length) {
      const searchOffsetTop = _.offset().top

      if (window.innerWidth > BREAKPOINT.MOBILE) {
        const breadcrumb = $('.container > .breadcrumb')
        const breadcrumbClone = breadcrumb.clone()
        const breadcrumbTempWrap = $('.main-search__breadcrubms')
        const breadcrumbTemp = $('.main-search__breadcrubms .breadcrumb')

        if ($('.main-search--advanced').exists()) {
          if (!breadcrumbTemp.exists()) {
            breadcrumbTempWrap.append(breadcrumbClone)
            breadcrumbComponent.init()
            $('.breadcrumb-list').find('ul').perfectScrollbar('destroy')
            $('.breadcrumb-list').find('ul').perfectScrollbar()
          }
          if ($('.static-stage--listing').exists()) {
            breadcrumb.css('visibility', 'hidden')
          } else {
            breadcrumb.css('display', 'none')
          }
        }
      }

      if (window.innerWidth > BREAKPOINT.DESKTOP) {
        $window.on('scroll', function() {
          //Console.log('ok')
          const _scrollTop = $window.scrollTop()
          const headerBottomOffsetTop = _scrollTop + $('.header.navbar-fixed-top').outerHeight()

          if (headerBottomOffsetTop >= searchOffsetTop) {
            if (!$('#campaignTimer').length) {
              _.parent().addClass('fixed')
            }
            mainWrap.css('padding-top', searchDesktopH)
          } else {
            _.parent().removeClass('fixed')
            mainWrap.removeAttr('style')
          }
        })
      }
    }
  },
}

module.exports = mainSearch



// WEBPACK FOOTER //
// ./src/modules/mainSearch.js